import ListingType, { ListingTypeNames } from '../enums/listing-type';
var listingTypesRegex = "(".concat(ListingTypeNames.map(listingType => ListingType[listingType].urlContext).join('|'), ")");
var ALLHOMES = 'allhomes.com.au';
export var SEARCH_PAGE = new RegExp("".concat(ALLHOMES, "/").concat(listingTypesRegex, "/search"));
export var SINGLE_SUBURB = new RegExp("".concat(ALLHOMES, "/").concat(listingTypesRegex, "/[^/]*-(act|nsw|qld|wa|vic|tas|sa)-\\d+/"));
export var NEW_LISTINGS = new RegExp('/new-listings/?(\\?[^/]+)?$');
export var PRICE_REDUCED = new RegExp('/new-price');
export var SEARCHES = [SEARCH_PAGE, NEW_LISTINGS, PRICE_REDUCED];